import { StatisticsBlock } from "@/shared/ui/statistics-block"
import { ReferrerDonutChart } from "../referrer-donut-chart"
import { ReferrerBarChart } from "../referrer-bar-chart"
import ChartSvg from '@/shared/assets/images/ChartBar.svg'
import CheckSvg from '@/shared/assets/images/Check.svg'
import UsersSvg from '@/shared/assets/images/UsersFour.svg'
import { useAppSelector } from "@/shared/lib/redux"
import { selectParticipationsCount, selectRegistrationsCount } from "@/entities/marketing-campaign"

export const DrawStatistics = () => {
    const totalParticipations = useAppSelector(selectParticipationsCount)
    const totalSubscribers = useAppSelector(selectParticipationsCount)
    const totalRegistered = useAppSelector(selectRegistrationsCount)

    return (
        <div className='grid grid-cols-12 gap-4'>
            <div className="col-span-12 xxl:col-span-6 screen:col-span-4">
                <StatisticsBlock
                    className="screen:!py-5"
                    icon={UsersSvg}
                    label='Количество участников'
                    value={`${totalParticipations}`}
                />
            </div>
            <div className="col-span-12 xxl:col-span-6 screen:col-span-4">
                <StatisticsBlock
                    className="screen:!py-5 [&_div]:!shrink-0"
                    icon={CheckSvg}
                    label='Количество регистраций в кошельке'
                    value={`${totalRegistered}`}
                />
            </div>
            <div className="col-span-12 xxl:col-span-12 screen:col-span-4">
                <StatisticsBlock
                    className="screen:!py-5"
                    icon={ChartSvg}
                    label='Количество подписок на канал'
                    value={`${totalSubscribers}`}
                />
            </div>
            <div className="col-span-6">
                <ReferrerDonutChart />
            </div>
            <div className="col-span-6">
                <ReferrerBarChart />
            </div>
        </div>
    )
}